/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
import React, { createRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import _ from 'lodash';
import Heading from '@tds/core-heading';
import Modal from '@tds/community-modal';

import request, { apiHost } from '../utils/request';
import FormField from './formField';
import ValidateLoader from '../UI/validateLoader';
import ProgressBar from '../design/progressBar';
import UserDetailsForm from './userDetailsForm';
import EquipmentSectionForm from './equipmentSectionFormVulcan';
import Note from '../note';
import RepeatedForm from './repeatedForm';
import { msgDisplay, getFieldValue, numberOfSelectedItems } from './utils';
import { getFormData, isRelatedFieldExisted } from './formStepFMVulcanUtils';
import { findField, normalizeEquipmentGroupSection } from './formStepUtils';
import { useTranslationsContext } from '../context/TranslationsContext';
import { Box } from '../design/css';
import { useLocaleContext } from '../context/LocaleContext';
import { GroupTitle, GroupWrapper } from './css';
import EN from '../../EN.json';
import FR from '../../FR.json';
import {
  typeCheckbox,
  maxUploadSizeValueWLS,
  maxUploadSizeErrorMessageWLS,
  inputTypeFile,
  keyFileSizeExceeded,
  roleLabels,
  localeFrench,
  stepKeyMain,
  fieldActivationLanguage,
  categoryVulcan,
  vulcanForm,
  isVulcanLandingPage,
  fieldPermitNumberUserAccountDetailVulcan,
  fieldExpirationKeyVulcan,
  fieldsKeyLocalStorage,
  vulcanLandingPage,
  fieldBusinessTypeVulcan,
  smokeDetectorWarningNoteVulcan,
  temperatureSensorFeeNote1Vulcan,
  temperatureSensorFeeNote2Vulcan,
  keyAdditionalEquipment,
  smokeFireDetectorVulcan,
  fieldsKeyLegalBusinessName,
  easyThreeYearSmokeFireDetectorVulcan,
  easyFiveYearSmokeFireDetectorVulcan,
  temperatureSensorVulcan,
  easyThreeYearTemperatureSensorVulcan,
  easyFiveYearTemperatureSensorVulcan,
  secureBusinessPlanVulcan,
  numberOfAccessPointsTotal,
  fieldNumberOfAccessPoints,
  controlIncludedEquipmentCameraSelectionVulcan,
  protectIncludedEquipmentCameraSelectionVulcan,
  regexBusinessInc,
  fieldAddProductVulcan,
  fieldWebFormOrderId,
  isCouponBasedDiscountField,
  keyMonitorAdditionalEquipmentVulcan,
  keyProtectAdditionalEquipmentVulcan,
  keyMonitorVulcan,
  keyProtectVulcan,
  fieldOrderIdTSB
} from '../utils/constant';
import { handleInstallationFeeDiscount } from './vulcanPricing/secureBusiness/secureBusiness';
import { secureBusinessOffersVulcan } from './vulcanPricing/secureBusiness/secureBusinessFieldNames';
import { localeFr, getPathVariables } from '../misc';
import { scrollToErrors } from '../utils/utils';
import {
  autoSelectAllAdvisories,
  permitNumbers
} from './vulcanHelpers/advisoriesHelpers';
import VulcanStatusBar from '../design/vulcanStatusBar';
import PrequalificationHelpers from './vulcanHelpers/prequalificationHelpers';
import CustomerHelpers from './vulcanHelpers/customerHelpers';
import VulcanOrderSummary from './orderSummary/vulcanOrderSummary';
import FibreBusinessWifiHelpers from './vulcanHelpers/fibreBusinessWifiHelpers';
import { preQualificationSectionErrorHandler } from './vulcanHelpers/errorHandlerHelpers';
import prequalificationSectionHelpers from './vulcanHelpers/prequalificationSectionHelpers';
import vulcanPricing from './vulcanPricing/vulcanPricing';
import { Error } from '../design/elements';
import additionalCustomerInformationHelpers from './vulcanHelpers/additionalCustomerInformationHelpers';
import stringInterpolation from '../utils/stringInterpolation';
import {
  SecureBusinessHelpers,
  getControlIncludedCameraTotal
} from './vulcanHelpers/secureBusinessHelpers';
import RedeemOfferVulcan from './vulcanHelpers/couponCode/RedeemOfferVulcan';

const formFieldsGroup = 'formFieldsGroup';
const formSection = 'formSection';
const userDetailsKey = 'userDetails';
const repeatedFormKey = 'repeatedForm';
const equipmentGroupSectionKey = 'equipmentGroupSection';
const typeMultiCheckbox = 'MultiCheckbox';
const formSectionTitle = 'formSectionTitle';
const profile = request.getProfile();

const initialEquipmentPrices = {
  subtractAmountFromPrice: 0,
  addAmountToPrice: 0,
  addAmountToMonthly: 0,
  subtractAmountFromMonthly: 0
};

const FormStepVulcan = ({
  stepData,
  steps,
  step,
  setFormRef,
  onFormSubmit,
  orderData,
  hideProgressBar,
  isEditing,
  formName,
  onSaveAndExit,
  updateStep,
  history,
  setOrderData,
  // eslint-disable-next-line react/prop-types
  isCreateOrderButtonVisible,
  stepDataForSummary
}) => {
  if (!stepData) return null;
  const translations = useTranslationsContext();
  const locale = useLocaleContext();

  const {
    formStep: {
      errorMessageInc,
      thisIsRequired
    },
    vulcanWebform: {
      yes,
      no,
      vulBusinessConnect,
      vulBusinessPersonalOption,
      vulBusinessRegularOption,
      vulNonProfitOrganizationOption,
      vulAccountDetails,
      vulProtectTSB,
      vulControlTSB,
      vulThreeMonthsFreeTSB,
      vulWaivedInstallationFeeOptionTSB,
      vulMonitorTSB
    }
  } = locale === 'en-US' ? EN : FR;

  const {
    contentfulValues: { valueEnglish, valueFrench },
    summaryForm: { summaryLabel },
    formStep: {
      minValueErrorMessage,
      maxValueErrorMessage,
      minLengthErrorMessage,
      maxLengthErrorMessage
    },
    modalForm: { fieldRequiredMessage }
  } = translations;
  const {
    fields: {
      name: formStepName,
      backendKey: formStepBackendKey,
      formStepFields,
      modalForms
    }
  } = stepData;
  const formStepRef = createRef();
  const [isLoading, setIsLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [formFields, setFormFields] = useState({});
  const [formFieldsForSummary, setFormFieldsForSummary ] = useState({});
  const [sections, setSections] = useState([]);
  const [dueNow, setDueNow] = useState(0);
  const [showDownloadQuoteFooter, setShowDownloadQuoteFooter] = useState(false);
  const [resetSection, setResetSection] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalText, setModalText] = useState('');
  const [modalOpenValidation, setModalOpenValidation] = useState(false);
  const [modalTextValidation, setModalTextValidation] = useState('');
  const { role } = (typeof profile !== 'undefined' && profile) || {};
  const [renderTempSensor, setRenderTempSensor] = useState(false);
  const [equipmentTotalPrice, setEquipmentTotalPrice] = useState(
    initialEquipmentPrices
  );
  const [hardwareDiscountAmount, setHadwareDiscountAmount] = useState(0);
  const [isHardwareDiscount, setIsHardwareDiscount] = useState(false);
  const [isExpanded,setIsExpanded] = useState(false);
  const [redeemOfferData, setRedeemOfferData] = useState({});

  const getDefaultValue = (key, value) => {
    if (isEditing && orderData) return orderData[key];
    return value || '';
  };

  const valueSecureBusinessPlanVulcan = getFieldValue(
    secureBusinessPlanVulcan,
    formFields
  );

  const open = sections.reduce((acc, section) => {
    const {
      fields: { name, isPanelInitiallyOpen, formFields: sectionFields }
    } = section;
    if (isPanelInitiallyOpen) {
      acc.push(name);
    } else {
      const isErrors =
        sectionFields &&
        sectionFields.find(item => {
          const {
            fields: { name: itemName }
          } = item;
          return formErrors[itemName];
        });
      if (typeof isErrors !== 'undefined') acc.push(name);
    }
    return acc;
  }, []);

  const validatedForOrderId = async () => {
    if (
      step === 1 &&
      formFields[fieldAddProductVulcan] &&
      formFields[fieldAddProductVulcan].value.includes(vulBusinessConnect)
    ) {
      try {
        await request.get(
          `/orders/validation/sof?webFormOrderId=${formFields[fieldWebFormOrderId].value}`
        );
        return false;
      } catch (error) {
        setModalTextValidation(error.response.data.error.message);
        setModalOpenValidation(true);
        return true;
      }
    }
    return false;
  };

  const normalizedFields = (data, initFields, isDefaultRequired) => {
    let result = initFields;
    if (data) {
      data.forEach(item => {
        const { sys, fields } = item;
        const {
          name,
          type,
          required,
          value,
          minValue,
          maxValue,
          minLength,
          maxLength,
          price,
          monthlyPayment,
          threeYearEasyPayment,
          fiveYearEasyPayment,
          options,
          tooltip,
          noteAppearsBelowField,
          customFieldErrorMessage,
          oneTimePrice,
          resetFields,
          customResetFields,
          label
        } = fields;
        const {
          contentType: {
            sys: { id }
          }
        } = sys;
        const key = name;
        const ref = createRef();
        let data1;
        if (Array.isArray(fields.formStepFields && fields.easyPaymentFields)) {
          data1 = [...fields.formStepFields, ...fields.easyPaymentFields];
        } else if (
          Array.isArray(fields.oneTimePaymentFields) &&
          Array.isArray(fields.threeYearEasyPaymentFields) &&
          Array.isArray(fields.fiveYearEasyPaymentFields)
        ) {
          data1 = [
            ...fields.oneTimePaymentFields,
            ...fields.threeYearEasyPaymentFields,
            ...fields.fiveYearEasyPaymentFields
          ];
        } else {
          data1 = fields.formStepFields;
        }
        const equipmentGroupData = { data: data1, isEditing, orderData, key };

        if (id === formFieldsGroup) {
          result = normalizedFields(fields.fields, result, isDefaultRequired);
        } else if (id === formSection) {
          result = normalizedFields(fields.formFields, result, isDefaultRequired);
        } else if (id === userDetailsKey) {
          result = normalizedFields(fields.formStepFields, result, isDefaultRequired);
        } else if (id === equipmentGroupSectionKey) {
          const formObjectKeys = normalizeEquipmentGroupSection(
            equipmentGroupData
          );
          result[key] = formObjectKeys;
        } else if (id === repeatedFormKey) {
          const formObjectKeys = fields.formFields.reduce(
            (acc, { fields: { name: formNameKey, value: defaultValue } }) => {
              acc[formNameKey] = defaultValue;
              return acc;
            },
            {}
          );
          result[fields.key] = [formObjectKeys];
        } else if (!Object.prototype.hasOwnProperty.call(result, key)) {
          let defaultValue = !isDefaultRequired ? getDefaultValue(key, value) : '';     
          let updatedMonthlyPayment = monthlyPayment;
          let updatedPrice = price;
          let updatedOneTimePrice = oneTimePrice;
          let updatedThreeYearEasyPayment = threeYearEasyPayment;
          let updatedFiveYearEasyPayment = fiveYearEasyPayment;

          if (['Select', 'Radio'].includes(type)) {
            if (options && defaultValue) {
              const currentOption = options.find(
                o => o.fields.value === defaultValue
              );
              if (typeof currentOption !== 'undefined') {
                updatedPrice = currentOption.fields.price;
                updatedMonthlyPayment = currentOption.fields.monthlyPayment;
                updatedOneTimePrice = currentOption.fields.oneTimePrice;
                updatedThreeYearEasyPayment =
                  currentOption.fields.threeYearEasyPayment;
                updatedFiveYearEasyPayment =
                  currentOption.fields.fiveYearEasyPayment;
              }
            }
          }
          if (type === typeMultiCheckbox) {
            if (defaultValue && defaultValue.length > 0 && options) {
              const updateDefaultValue =
                typeof defaultValue === 'string'
                  ? defaultValue.split(',')
                  : defaultValue;
              const mappedValues = updateDefaultValue.reduce(
                (ac, a) => ({ ...ac, [a]: true }),
                {}
              );
              updatedPrice = options.reduce(
                (ac, a) =>
                  ac + ((mappedValues[a.fields.value] && a.fields.price) || 0),
                0
              );
              updatedMonthlyPayment = options.reduce(
                (ac, a) =>
                  ac +
                  ((mappedValues[a.fields.value] && a.fields.monthlyPayment) ||
                    0),
                0
              );
            }
          }
          /**
           * Condition to select default activation lagnguage
           * based on the curren locale
           */
          if (key === fieldActivationLanguage) {
            const currentLocale = getPathVariables(window.location.pathname)[0];
            defaultValue =
              currentLocale === localeFr ? valueFrench : valueEnglish;
          }
          result[key] = {
            name,
            ref,
            type,
            value: defaultValue || value,
            initPrice: updatedPrice || 0,
            price: updatedPrice || 0,
            initMonthlyPayment: updatedMonthlyPayment || 0,
            monthlyPayment: updatedMonthlyPayment || 0,
            initOneTimePrice: updatedOneTimePrice || 0,
            oneTimePrice: updatedOneTimePrice || 0,
            initThreeYearEasyPayment: updatedThreeYearEasyPayment || 0,
            threeYearEasyPayment: updatedThreeYearEasyPayment || 0,
            initFiveYearEasyPayment: updatedFiveYearEasyPayment || 0,
            fiveYearEasyPayment: updatedFiveYearEasyPayment || 0,
            minValue,
            maxValue,
            minLength,
            maxLength,
            isRequired: required || false,
            isVisible: true,
            options,
            tooltip,
            noteAppearsBelowField,
            customFieldErrorMessage,
            fieldLabel: label
          };
          if (resetFields) {
            result[key].resetFields = resetFields;
          }

          if (customResetFields) {
            result[key].customResetFields = customResetFields;
          }
          if (type === 'Checkbox') {
            result[key].checked = defaultValue;
          }
          if (
            type === 'PlusMinusInput' &&
            defaultValue === undefined &&
            value
          ) {
            result[key].value = value;
          }
        }
      });
    }
    return result;
  };

  const formSections = formStepFields.filter(({ sys }) => {
    const {
      contentType: {
        sys: { id }
      }
    } = sys;
    return id === formSection;
  });

  const getHiddenSections = fields => {
    const hiddenSections = [];
    formSections.forEach(section => {
      const {
        fields: { name: sectionName }
      } = section;
      if (
        !isRelatedFieldExisted(section.fields, fields, orderData, isFormTouched)
      ) {
        hiddenSections.push(sectionName);
      }
    });
    return hiddenSections;
  };

  const updateSections = updatedSections => {
    let newSections = [...formSections];
    updatedSections.forEach(item => {
      newSections = newSections.filter(section => section.fields.name !== item);
    });
    setSections(newSections);
  };

  useEffect(() => {
    if (
      (!isEditing && formStepFields) ||
      (isEditing && orderData && orderData.id)
    ) {
      const updatedFields = normalizedFields(formStepFields, formFields);
      if (stepDataForSummary) {
        const updatedFieldsForSummary = normalizedFields(
          stepDataForSummary.fields.formStepFields,
          formFieldsForSummary,
          true
        );
        setFormFieldsForSummary(updatedFieldsForSummary);
      }
      setFormFields(updatedFields);
      updateSections(getHiddenSections(updatedFields));
      setIsLoading(false);
      setIsFormTouched(false);
      if (formStepRef && formStepRef.current)
        formStepRef.current.scrollTo(0, 0);
    }
  }, [formStepFields, orderData, locale, resetSection]);

  const sectionIsVisible = name => typeof sections.find(item => item.fields.name === name) !== 'undefined';

  const getRepeatedFormErrors = (contentfulFields, formValues) => {
    const fields = contentfulFields.filter(
      ({ fields: content }) => content.required || content.fieldValidation
    );
    return formValues.filter(formValue => {
      let filteredValues = fields.filter(
        ({ fields: { name: formKeyValue } }, index) => {
          return (
            !formValue[formKeyValue] || fields[index].fields.fieldValidation
          );
        }
      );
      const removeValidationErrors =
        filteredValues &&
        filteredValues.filter(item => {
          if (item.fields.fieldValidation) {
            if (
              item.fields.fieldValidation.fields.logic &&
              item.fields.fieldValidation.fields.logic === 'regex'
            ) {
              // Add regex logic
            }
          }
          return null;
        });
      filteredValues = removeValidationErrors;
      return filteredValues.length > 0;
    });
  };

  const getAccumulatedFilesSize = files => {
    const keys = Object.keys(files);
    let size = 0;
    // eslint-disable-next-line no-unused-expressions
    keys.length > 0 &&
      keys.forEach(key => {
        if (files[key]) {
          const [file] = Object.keys(files[key]);
          if (files[key][file] && files[key][file].size) {
            size += files[key][file].size;
          }
        }
      });
    return size;
  };

  const getErrors = (data, errors) => {
    scrollToErrors(errors);
    let result = errors;
    const fieldsValue = [];
    if (!data) return result;
    data.forEach(({ sys, fields }) => {
      const {
        contentType: {
          sys: { id }
        }
      } = sys;
      const { name: key, type, customFieldErrorMessage } = fields;

      const {
        value,
        minValue,
        maxValue,
        isRequired,
        isVisible,
        ref,
        minLength,
        maxLength
      } =
        formFields &&
        Object.prototype.hasOwnProperty.call(formFields, key) &&
        formFields[key];
      const { files } = formFields;

      if (
        id === formFieldsGroup &&
        isRelatedFieldExisted(fields, formFields, orderData, isFormTouched)
      ) {
        result = getErrors(fields.fields, result);
      } else if (id === formSection && sectionIsVisible(key)) {
        result = getErrors(fields.formFields, result);
      } else if (id === userDetailsKey) {
        result = getErrors(fields.formStepFields, result);
      } else if (id === equipmentGroupSectionKey) {
        if (
          valueSecureBusinessPlanVulcan === vulProtectTSB &&
          [protectIncludedEquipmentCameraSelectionVulcan].includes(key) &&
          formFields &&
          getControlIncludedCameraTotal(formFields[key]) < 1
        ) {
          result[key] = {
            text: 'Select a total of 1 camera above',
            ref
          };
        } else if (
          valueSecureBusinessPlanVulcan === vulControlTSB &&
          [controlIncludedEquipmentCameraSelectionVulcan].includes(key) &&
          formFields &&
          getControlIncludedCameraTotal(formFields[key]) < 2
        ) {
          result[key] = {
            text: 'Select a total of 2 cameras above',
            ref
          };
        } else {
          delete result[key];
        }
      } else if (id === repeatedFormKey) {
        const repeatedFormErrors = getRepeatedFormErrors(
          fields.formFields,
          formFields[fields.key]
        );
        if (repeatedFormErrors.length) {
          result[fields.key] = repeatedFormErrors;
        } else {
          delete result[fields.key];
        }
      } else if (isVisible) {
        if (isRequired) {
          let fieldValue = value;
          if (type === typeMultiCheckbox) {
            const multiCheckboxValue = getFieldValue(key, formFields);
            fieldValue = multiCheckboxValue && multiCheckboxValue.length > 0;
          }
          if (
            !fieldValue &&
            isRelatedFieldExisted(fields, formFields, orderData, isFormTouched)
          ) {
            if (!(type === typeCheckbox && formFields[key].checked)) {
              result[key] = {
                text: customFieldErrorMessage || fieldRequiredMessage,
                ref
              };
            } else {
              delete result[key];
            }
          } else {
            delete result[key];
          }
        }
        if (typeof minValue !== 'undefined' && parseFloat(value) < minValue) {
          result[key] = {
            text: msgDisplay(minValue, minValueErrorMessage),
            ref
          };
        }
        if (typeof maxValue !== 'undefined' && parseFloat(value) > maxValue) {
          result[key] = {
            text: msgDisplay(maxValue, maxValueErrorMessage),
            ref
          };
        }
        if (minLength && value && value.length < minLength) {
          result[key] = {
            text: msgDisplay(minLength, minLengthErrorMessage),
            ref
          };
        }
        if (maxLength && value && value.length > maxLength) {
          result[key] = {
            text: msgDisplay(maxLength, maxLengthErrorMessage),
            ref
          };
        }
        if (type === inputTypeFile && files) {
          if (getAccumulatedFilesSize(files) > maxUploadSizeValueWLS) {
            result[keyFileSizeExceeded] = {
              text: maxUploadSizeErrorMessageWLS,
              ref
            };
          } else {
            delete result[keyFileSizeExceeded];
          }
        }
        const valueBusinessTypeVulcan = getFieldValue(fieldBusinessTypeVulcan, formFields);
        const valueLegalBusinessName= getFieldValue(fieldsKeyLegalBusinessName, formFields);
        if (key === fieldsKeyLegalBusinessName) {
          const legalBusinessNamePattern = new RegExp(regexBusinessInc, 'i'); 
          if ([vulBusinessPersonalOption, vulNonProfitOrganizationOption].includes(valueBusinessTypeVulcan) && !valueLegalBusinessName) {
              result.legalBusinessName = {
                  text: thisIsRequired,
                  ref
              };
          } else if (!legalBusinessNamePattern.test(valueLegalBusinessName) && valueBusinessTypeVulcan === vulBusinessRegularOption) {
              result.legalBusinessName = {
                  text: errorMessageInc,
                  ref
              };
          } else {
              delete result[fieldsKeyLegalBusinessName];
          }
      }
        // if (key === fieldUseInternet) {
        //   const useInternet = getFieldValue(fieldUseInternet, formFields);
        //   const currentInternetProviderName = getFieldValue(
        //     fieldCurrentInternetProviderName,
        //     formFields
        //   );
        //   if (useInternet && currentInternetProviderName) {
        //     if (
        //       useInternet === greaterThanTenOption &&
        //       [bellOption, virginOption].includes(currentInternetProviderName)
        //     ){
        //       result[fieldUseInternet] = {
        //         text: 'Customer does not qualify for TELUS PureFibre bundle.'
        //       };
        //     }else{
        //       delete result[fieldUseInternet];
        //     }
        //   }
        // }

        preQualificationSectionErrorHandler({
          key,
          value,
          result,
          ref,
          fieldsValue,
          sections
        });

        if (key === 'redeemOffer') {
          if (
            formFields[isCouponBasedDiscountField].value === yes &&
            redeemOfferData.redeemOfferSelection.length === 0
          ) {
            result.redeemOfferData = {
              text: 'Add coupon',
              ref
            };
          } else {
            delete result.redeemOfferData;
          }
        }
        // Only need to show note
        // addProductVulcanErrorHandler({ key, value, ref, result });

        if (fields.fieldValidation && fields.fieldValidation.fields) {
          if (
            typeof fields.appearsAfterField === 'undefined' ||
            (typeof fields.appearsAfterField !== 'undefined' &&
              isRelatedFieldExisted(
                fields,
                formFields,
                orderData,
                isFormTouched
              ))
          ) {
            const {
              errorMessage,
              logic,
              value: expectedValue
            } = fields.fieldValidation.fields;
            let hasError = false;
            switch (logic) {
              case 'equal':
                // eslint-disable-next-line eqeqeq
                hasError = !expectedValue.split('|').includes(value);
                break;
              case 'regex':
                {
                  const regexLogic = new RegExp(expectedValue);
                  hasError = !regexLogic.test(value);
                }
                break;
              case 'gt':
                hasError = parseInt(value, 10) < parseInt(expectedValue, 10);
                break;
              case 'gte':
                hasError = parseInt(value, 10) <= parseInt(expectedValue, 10);
                break;
              case 'lt':
                hasError = parseInt(value, 10) < parseInt(expectedValue, 10);
                break;
              default:
            }
            if (hasError) result[key] = { text: errorMessage, ref };
            if ((!isRequired && !value) || (!isRequired && !hasError))
              delete result[key];
          }
        }
      }
    });
    return result;
  };

  const saveAndExit = async () => {
    const fields = getFormData(formFields, step);
    if (Object.entries(fields).length) {
      const validatedOrderIdOfBusinessConnect = await validatedForOrderId();
      if (validatedOrderIdOfBusinessConnect) {
        return;
      }
      onSaveAndExit(fields);
    }
  };

  const prevStep = e => {
    e.preventDefault();
    setFormErrors({});
    setIsLoading(true);
    if (
      orderData.addProductVulcan.includes(vulBusinessConnect) &&
      step === 3
    ) {
      // remove steps from here
      updateStep(step - 2);
    } else if (orderData && orderData.orderIdTSB && step === 3) {
      updateStep(step - 2);
    } else {
      updateStep(step - 1);
    }

    history.push({
      pathname: `/${locale}/${categoryVulcan}/${vulcanForm}`,
      search: `?orderId=${orderData.id}&step=${step - 1}&isEditing=true`
    });
  };

  const nextStep = async e => {
    e.preventDefault();
    const errors = getErrors(formStepFields, { ...formErrors });
    setFormErrors(errors);
    if (Object.entries(errors).length === 0) {
      const validatedOrderIdOfBusinessConnect = await validatedForOrderId();
      if (validatedOrderIdOfBusinessConnect) {
        return;
      }
      const shouldShowDownloadQuote =
        formName !== vulcanLandingPage &&
        !showDownloadQuoteFooter &&
        step === 1;
      setShowDownloadQuoteFooter(shouldShowDownloadQuote);
      const fields = getFormData(formFields, step, formFieldsForSummary, redeemOfferData);
      onFormSubmit(fields, !shouldShowDownloadQuote, step === steps.length);
    } else {
      const firstError = errors[Object.keys(errors)[0]];
      const { ref } = firstError;
      if (ref && ref.current) ref.current.focus();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  const resetFormFields = (fields, name) => {
    const { resetFields, customResetFields } = fields[name];
    const updatedFields = Object.keys(fields).reduce((acc, fieldKey) => {
      const currentFormField = findField(formStepFields, fieldKey);
      // If field type is array, then it'll be ignored with the below logic
      if (_.isArray(fields[fieldKey])) {
        return { ...acc, [fieldKey]: fields[fieldKey] };
      }
      const isVisible = isRelatedFieldExisted(
        _.get(currentFormField, 'fields', {}),
        fields,
        orderData,
        true
      );
      if (!isVisible)
        return { ...acc, [fieldKey]: { ...fields[fieldKey], value: '' } };
      return { ...acc, [fieldKey]: { ...fields[fieldKey] } };
    }, {});

    if (resetFields) {
      resetFields.forEach(field => {
        const fieldName = _.get(field, 'fields.name', '');
        if (fieldName && _.has(updatedFields[fieldName], 'value'))
          updatedFields[fieldName].value = '';
      });
    }
    if (customResetFields) {
      customResetFields.forEach(field => {
        const fieldName = _.get(field, 'fields.key', '');
        if (fieldName && _.has(updatedFields[fieldName], 'value'))
          updatedFields[fieldName].value = '';
        else delete updatedFields[fieldName];
      });
    }

    return updatedFields;
  };

  const resetSelectedFields = (fields, isCustom = false) => {
    if (fields.length > 0) {
      const updatedOrderData = { ...orderData };
      fields.forEach(field => {
        const keyPath = isCustom ? 'fields.key' : 'fields.name';
        const fieldName = _.get(field, keyPath, '');
        if (_.has(orderData, fieldName)) {
          updatedOrderData[fieldName] = '';
        }
      });
      // setIsFieldReset(true);
      setOrderData(updatedOrderData);
    }
  };

  // This Function is use when you reset the orderData with priceSelections
  const resetOrderData = field => {
    if (orderData[field]) {
      orderData[field] = {};
      delete orderData.priceSelections[field];
      setOrderData(orderData);
    }
  };

  const handleFormField = (
    { name, value, checked, files },
    ref,
    isFieldModified
  ) => {
    const fields = { ...formFields };

    // if(name === secureBusinessPlanVulcan && fields[secureBusinessOffersVulcan].value.includes('$199 Waive Installation Fee')){
    //   formFields[secureBusinessOffersVulcan].value = [tenDollarBundleDiscountOption]
    // }

    if (isFieldModified && !isFormTouched) {
      setIsFormTouched(true);
      setShowDownloadQuoteFooter(false);
    }
    fields[name] = { ...fields[name], value, checked, isVisible: true };

    if ([fieldNumberOfAccessPoints].includes(name) && value === '4') {
      setModalText(
        stringInterpolation(
          'Note: Maximum total number of Number of Access Points should be %s',
          numberOfAccessPointsTotal
        )
      );
      setModalOpen(true);
      return;
    }

    if (name === isCouponBasedDiscountField) {
      if (value === no) {
        resetOrderData('redeemOfferData');
        setRedeemOfferData({});
      }
    }

    // * Auto select all adivsories to YES * when Yes to ALL is selected
    autoSelectAllAdvisories(name, fields, checked, setFormFields);

    // Form sections visibility can be related to fields and values
    updateSections(getHiddenSections(fields));
    if (files && files.length) {
      const [file] = files;
      const checkFileExists = (filesToCheck, fileKey) =>
        filesToCheck.find(fileDetails => fileDetails[fileKey]);
      const updateFile = (fileList, fileKey, updatedFile) => {
        const updatedFileList = fileList.map(fileDetails => {
          if (fileDetails[fileKey]) {
            // eslint-disable-next-line no-param-reassign
            fileDetails[name] = updatedFile;
          }
          return fileDetails;
        });
        return updatedFileList;
      };
      if (
        fields.files &&
        fields.files.length &&
        !checkFileExists(fields.files, name)
      ) {
        fields.files.push({ [name]: file });
      } else if (
        fields.files &&
        fields.files.length &&
        checkFileExists(fields.files, name)
      ) {
        const updatedFileList = updateFile(fields.files, name, file);
        fields.files = updatedFileList;
      } else {
        fields.files = [{ [name]: file }];
      }
      fields[name].value = file.name;
    }
    setFormFields(resetFormFields(fields, name));

    // Reset Selected Fields Logic
    if (_.has(fields, `${name}.resetFields`)) {
      resetSelectedFields(_.get(fields, `${name}.resetFields`, []));
    } else if (_.has(fields, `${name}.customResetFields`)) {
      resetSelectedFields(_.get(fields, `${name}.customResetFields`, []), true);
    }
  };

  const renderFormFields = data =>
    data &&
    data.length > 0 &&
    data.map(({ sys, fields }, indexRoot) => {
      const {
        contentType: {
          sys: { id }
        },
        id: sysId
      } = sys;
      const { name: fieldName, title, expiredDate } = fields;
      let selectOptions;
      const error = formErrors[fieldName];
      const key = `FormField${fieldName}${indexRoot}${sysId}`;
      let result;
      let fieldNote;

      // This function is use to handel Dashboard Prequalification Section logic
      const returnValueOfPrequalification = PrequalificationHelpers({
        isCreateOrderButtonVisible,
        formFields,
        fieldName
      });

      // This function is use to handel Customer Section logic
      const returnValueOfCustomer = CustomerHelpers({
        fieldName,
        formFields,
        setResetSection
      });

      const returnValueOfSecureBusiness = SecureBusinessHelpers({
        fieldName,
        formFields,
        fields
      });

      // This function is use to handel Quote Prequalification Section logic
      const returnPrequalificationSection = prequalificationSectionHelpers({
        fieldName,
        formFields
      });

      const additionalCustomerInformation = additionalCustomerInformationHelpers(
        {
          fieldName,
          formFields,
          orderData
        }
      );
      const valueofTSBId = getFieldValue(fieldOrderIdTSB, formFields);

      // This function is use to handel Fibre and BusinessWifi Section logic
      FibreBusinessWifiHelpers({ formFields, fieldName, fields });

      if (
        returnValueOfPrequalification ||
        returnValueOfCustomer ||
        returnPrequalificationSection ||
        additionalCustomerInformation ||
        returnValueOfSecureBusiness
      ) {
        return null;
      }
      const valueSecureBusinessOffersVulcan = getFieldValue(
        secureBusinessOffersVulcan,
        formFields
      );

      if (
        fieldName === secureBusinessOffersVulcan &&
        valueSecureBusinessOffersVulcan.includes(vulThreeMonthsFreeTSB)
      ) {
        let threeMonthsFreeTSBPrice;

        formFields[secureBusinessPlanVulcan].options.map(field => {
          if (field.fields.value === formFields[secureBusinessPlanVulcan].value) {
            threeMonthsFreeTSBPrice = field.fields.monthlyPayment;
          }
        });

        const vulcanOption = formFields.secureBusinessOffersVulcan.options.find(
          option => option.fields.label === vulThreeMonthsFreeTSB
        );

        if (vulcanOption) {
          vulcanOption.fields.monthlyPayment = -threeMonthsFreeTSBPrice;
        }
      }

      if (fieldName === secureBusinessOffersVulcan) {
        const secureBusinessPlanVulcanValue = getFieldValue(secureBusinessPlanVulcan, formFields);
        let numberOfSelectedAdditionalEquipments;
        switch (secureBusinessPlanVulcanValue) {
          case vulMonitorTSB:
            numberOfSelectedAdditionalEquipments = numberOfSelectedItems(formFields[keyMonitorAdditionalEquipmentVulcan]);
            break;
          case vulProtectTSB:
            numberOfSelectedAdditionalEquipments = numberOfSelectedItems(formFields[keyProtectAdditionalEquipmentVulcan]);
            break;
          default:
            numberOfSelectedAdditionalEquipments = 0;
        }

        handleInstallationFeeDiscount(fields, numberOfSelectedAdditionalEquipments);
        handleInstallationFeeDiscount(formFields[secureBusinessOffersVulcan], numberOfSelectedAdditionalEquipments);
      }

      if (fieldName === secureBusinessPlanVulcan) {
        formFields.secureBusinessPlanVulcan.options.map((field) => {
          const match = field.fields.label.match(/\$(\d+)/);

          const price = match ? parseInt(match[1], 10) : 0;

          field.fields.monthlyPayment = price - 10;
        });
      }

      if (expiredDate && new Date(expiredDate) < new Date()) return null;
      if (!isRelatedFieldExisted(fields, formFields, orderData, isFormTouched))
        return null;
      const fieldValue = getFieldValue(fieldName, formFields);
      const permitNumber = getFieldValue(
        fieldPermitNumberUserAccountDetailVulcan,
        formFields
      );
      const obj = {};

      const permit = permitNumbers(
        permitNumber,
        fields,
        fieldName,
        vulAccountDetails,
        fieldExpirationKeyVulcan,
        fieldsKeyLocalStorage,
        obj
      );

      if (permit) {
        return null;
      }
      if (id === formFieldsGroup) {
        const groupIsVisible = fields.fields.find(item => {
          const { fields: itemFields } = item;
          if (!formFields[itemFields.name]) return null;
          const { value, isVisible } = formFields[itemFields.name];
          return (
            (value && isVisible) ||
            isRelatedFieldExisted(
              itemFields,
              formFields,
              orderData,
              isFormTouched
            )
          );
        });
        if (typeof groupIsVisible !== 'undefined') {
          result = (
            <GroupWrapper key={key}>
              {title && <GroupTitle>{title}</GroupTitle>}
              {renderFormFields(fields.fields)}
            </GroupWrapper>
          );
        }
      } else if (id === formSectionTitle) {
        const { title: sectionTitle } = fields;
        return <Heading level="h3">{sectionTitle}</Heading>;
      } else if (id === formSection) {
        // below if condition is made not to be executed due to some rendering issues(for Annas)
        if (step === 5 && formStepName === 'Order Summaryy') {
          result = orderData && steps && (
            <VulcanOrderSummary stepData={steps} orderData={orderData} />
          );
        } else {
          const { note } = fields;
          const renderNote = note && note.content && (
            <Note data={note} type="richText" />
          );
          const { name } = role || {};
          result = sectionIsVisible(fieldName) && (
            <ExpandCollapse.Panel
              onToggle={e => setIsExpanded(e)}
              key={key}
              id={fieldName}
              header={
                formStepBackendKey === stepKeyMain && locale !== localeFrench
                  ? `${roleLabels[name]} ${title}`
                  : `${title}`
              }
            >
              <>
                {renderNote && renderNote}
                {renderFormFields(fields.formFields)}
                {step === 5 && (
                  <VulcanOrderSummary stepData={steps} orderData={orderData} />
                )}
                {/* {formSummaryGroup
          ? renderFormSummary(formSummaryGroup)
          : renderFormFields(fields.formFields)} */}
              </>
            </ExpandCollapse.Panel>
          );
        }
      } else if (id === userDetailsKey) {
        const disabled = false;
        const isSameAsCheckboxChecked = false;
        result = (
          <UserDetailsForm
            key={key}
            data={fields}
            setFormFields={setFormFields}
            orderData={orderData}
            formErrors={formErrors}
            formFields={formFields}
            isEditing={isEditing}
            isFormTouched={isFormTouched}
            setIsFormTouched={setIsFormTouched}
            disabled={disabled}
            isSameAsCheckboxChecked={isSameAsCheckboxChecked}
          />
        );
      } else if (id === repeatedFormKey) {
        result = (
          <RepeatedForm
            key={key}
            data={fields}
            setFormFields={setFormFields}
            orderData={orderData}
            formErrors={formErrors}
            formFields={formFields}
            isEditing={isEditing}
            isFormTouched={isFormTouched}
            setIsFormTouched={setIsFormTouched}
          />
        );
      } else if (id === equipmentGroupSectionKey) {
        const tempError = formErrors[fields.name];
        result = (
          <>
            <EquipmentSectionForm
              key={key}
              data={fields}
              setFormFields={setFormFields}
              formErrors={formErrors}
              formFields={formFields}
              isEditing={isEditing}
              isFormTouched={isFormTouched}
              setIsFormTouched={setIsFormTouched}
              equipmentTotalPrice={equipmentTotalPrice}
              setEquipmentTotalPrice={setEquipmentTotalPrice}
              hardwareDiscountAmount={hardwareDiscountAmount}
              setHadwareDiscountAmount={setHadwareDiscountAmount}
              dueNow={dueNow}
              setDueNow={setDueNow}
              isHardwareDiscount={isHardwareDiscount}
              renderTempSensor={renderTempSensor}
              setRenderTempSensor={setRenderTempSensor}
              isExpanded={isExpanded}
              setShowDownloadQuoteFooter={setShowDownloadQuoteFooter}
            />
            {tempError && <Error text={tempError.text} />}
          </>
        );
      } else if (id === 'note') {
        const dataObj = {
          type: 'TextNote',
          note: fields.content,
          isShowNoteBackground: true
        };
        result = <FormField data={dataObj} />;
      } else if (fields.type === 'CouponBasedDiscount') {
        return (
          <RedeemOfferVulcan
            onChange={setRedeemOfferData}
            orderData={_.get(orderData, 'redeemOfferData', {})}
            buttonError={formErrors.redeemOfferData}
            setIsFormTouched={setIsFormTouched}
            setShowDownloadQuoteFooter={setShowDownloadQuoteFooter}
          />
        );
      } else {
        const fieldButtonProps = fields.type === 'Button' ? { modalForms } : {};
        let ref;
        let isDisabled;
        if (formFields[fieldName]) {
          ({ ref, isDisabled } = formFields[fieldName]);
        }
        const newFields = [];
        const update = false;
        // const channelName = profile.channel ? profile.channel.name : null;
        const fieldData = {
          ...fields,
          options: selectOptions || update ? newFields : fields.options,
          ...fieldButtonProps,
          note: fieldNote || fields.note,
          ref,
          formFields,
          name: fieldName,
          value: fieldValue,
          disabled: isDisabled,
          readonly: isDisabled,
          sysId,
          onChange: (e, refV) => handleFormField(e.target, refV, true),
          onBlur: () => {},
          resetSelectedFields
        };

        //  Changes for Secure Business Product
        const selectedPackageOption = getFieldValue(
          secureBusinessPlanVulcan,
          formFields
        );
        const frenchToEnglishMap = {
          Surveillance: 'Monitor',
          Protection: 'Protect',
          Contrôle: 'Control'
        };
        let translatedPackageOption = selectedPackageOption;

        if (locale === 'fr-CA' && frenchToEnglishMap[selectedPackageOption]) {
          translatedPackageOption = frenchToEnglishMap[selectedPackageOption];
        }
        let selectedPackage =
          translatedPackageOption && translatedPackageOption.slice(0, 7);

        const isSmokeDetectorAddedVulcan = products => {
          let isAdded = false;

          products.forEach(product => {
            if (
              formFields[`${selectedPackage}${keyAdditionalEquipment}Vulcan`] &&
              formFields[`${selectedPackage}${keyAdditionalEquipment}Vulcan`][
                product
              ] &&
              formFields[`${selectedPackage}${keyAdditionalEquipment}Vulcan`][
                product
              ].value > 0
            ) {
              isAdded = true;
            }
          });
          return isAdded;
        };
        if (typeof selectedPackage === 'string' && !valueofTSBId) {
          selectedPackage = selectedPackage.toLowerCase();
        } else if (fieldName === smokeDetectorWarningNoteVulcan) {
          return null;
        } else if (fieldName === temperatureSensorFeeNote1Vulcan) {
          return null;
        } else if (fieldName === temperatureSensorFeeNote2Vulcan) {
          return null;
        }
        if (
          selectedPackage &&
          formFields[`${selectedPackage}${keyAdditionalEquipment}Vulcan`] &&
          fieldName === smokeDetectorWarningNoteVulcan
        ) {
          if (
            isSmokeDetectorAddedVulcan([
              smokeFireDetectorVulcan,
              easyThreeYearSmokeFireDetectorVulcan,
              easyFiveYearSmokeFireDetectorVulcan
            ]) === false
          ) {
            fieldData.note = '';
          }
        }
        // SOF-1773
        const isTemperatureSensorAdded1Vulcan = products => {
          let isAdded = false;
          products.forEach(product => {
            if (
              formFields[`${selectedPackage}${keyAdditionalEquipment}Vulcan`] &&
              formFields[`${selectedPackage}${keyAdditionalEquipment}Vulcan`][
                product
              ] &&
              (formFields[`${selectedPackage}${keyAdditionalEquipment}Vulcan`][
                temperatureSensorVulcan
              ].value || 0) +
                (formFields[
                  `${selectedPackage}${keyAdditionalEquipment}Vulcan`
                ][easyThreeYearTemperatureSensorVulcan].value || 0) +
                (formFields[
                  `${selectedPackage}${keyAdditionalEquipment}Vulcan`
                ][easyFiveYearTemperatureSensorVulcan].value || 0) >
                0 &&
              (formFields[`${selectedPackage}${keyAdditionalEquipment}Vulcan`][
                temperatureSensorVulcan
              ].value || 0) +
                (formFields[
                  `${selectedPackage}${keyAdditionalEquipment}Vulcan`
                ][easyThreeYearTemperatureSensorVulcan].value || 0) +
                (formFields[
                  `${selectedPackage}${keyAdditionalEquipment}Vulcan`
                ][easyFiveYearTemperatureSensorVulcan].value || 0) <=
                5
            ) {
              isAdded = true;
            }
          });
          return isAdded;
        };

        if (
          selectedPackage &&
          formFields[`${selectedPackage}${keyAdditionalEquipment}Vulcan`] &&
          fieldName === temperatureSensorFeeNote1Vulcan
        ) {
          if (
            isTemperatureSensorAdded1Vulcan([
              temperatureSensorVulcan,
              easyThreeYearTemperatureSensorVulcan,
              easyFiveYearTemperatureSensorVulcan
            ]) === false
          ) {
            fieldData.note = '';
          }
        }

        const isTemperatureSensorAdded2Vulcan = products => {
          let isAdded = false;
          products.forEach(product => {
            if (
              formFields[`${selectedPackage}${keyAdditionalEquipment}Vulcan`] &&
              formFields[`${selectedPackage}${keyAdditionalEquipment}Vulcan`][
                product
              ] &&
              (formFields[`${selectedPackage}${keyAdditionalEquipment}Vulcan`][
                temperatureSensorVulcan
              ].value || 0) +
                (formFields[
                  `${selectedPackage}${keyAdditionalEquipment}Vulcan`
                ][easyThreeYearTemperatureSensorVulcan].value || 0) +
                (formFields[
                  `${selectedPackage}${keyAdditionalEquipment}Vulcan`
                ][easyFiveYearTemperatureSensorVulcan].value || 0) >
                5 &&
              (formFields[`${selectedPackage}${keyAdditionalEquipment}Vulcan`][
                temperatureSensorVulcan
              ].value || 0) +
                (formFields[
                  `${selectedPackage}${keyAdditionalEquipment}Vulcan`
                ][easyThreeYearTemperatureSensorVulcan].value || 0) +
                (formFields[
                  `${selectedPackage}${keyAdditionalEquipment}Vulcan`
                ][easyFiveYearTemperatureSensorVulcan].value || 0) <=
                10
            ) {
              isAdded = true;
            }
          });
          return isAdded;
        };

        if (
          selectedPackage &&
          formFields[`${selectedPackage}${keyAdditionalEquipment}Vulcan`] &&
          fieldName === temperatureSensorFeeNote2Vulcan
        ) {
          if (
            isTemperatureSensorAdded2Vulcan([
              temperatureSensorVulcan,
              easyThreeYearTemperatureSensorVulcan,
              easyFiveYearTemperatureSensorVulcan
            ]) === false
          ) {
            fieldData.note = '';
          }
        }

        if (!isFormTouched && fields.type === 'Checkbox') {
          fieldData.checked = fieldValue;
        }
        result = (
          <FormField key={key} data={fieldData} error={error && error.text} />
        );
      }
      return result;
    });

  return (
    <div ref={formStepRef}>
      {!hideProgressBar && (
        <ProgressBar
          name={formStepName}
          steps={steps}
          currentStep={step}
          locale={locale}
          formName={formName}
        />
      )}
      <div></div>
      {isLoading ? (
        <ValidateLoader
          message="Please wait request is In progress...."
          isFormStep
        />
      ) : (
        <form
          name={formStepName}
          onSubmit={e => nextStep(e)}
          ref={ref => setFormRef && setFormRef(ref)}
        >
          {sections.length && formStepName !== isVulcanLandingPage ? (
            <Box
              style={{
                border: '1px solid #e3e3e3',
                boxShadow: '1px 1px 9px 4px #e3e3e3',
                padding: '2rem',
                marginBottom: '1rem',
                marginLeft: '4rem',
                marginRight: '4rem'
              }}
            >
              <div className="expand">
                <ExpandCollapse tag="h2" topDivider={false} open={[...open]}>
                  {renderFormFields(formStepFields)}
                </ExpandCollapse>
              </div>
            </Box>
          ) : (
            <div style={{ width: '1000px' }}>
              {formStepFields ? (
                <Box
                  style={{
                    border: '1px solid #e3e3e3',
                    boxShadow: '1px 1px 9px 4px #e3e3e3',
                    padding: '2rem',
                    marginBottom: '1rem',
                    marginLeft: '4rem',
                    marginRight: '4rem'
                  }}
                >
                  <div className="expand">
                    <ExpandCollapse
                      tag="h2"
                      topDivider={false}
                      open={[...open]}
                    >
                      {renderFormFields(formStepFields)}
                    </ExpandCollapse>
                  </div>
                </Box>
              ) : (
                <>
                  <h3 style={{ marginBottom: '1em' }}>{summaryLabel}</h3>
                  {/* {getSummary()} */}
                </>
              )}
            </div>
          )}
          <Modal
            heading="Alert"
            bodyText={modalText}
            onClose={() => setModalOpen(false)}
            isOpen={modalOpen}
          />
          <Modal
            heading="Alert"
            bodyText={modalTextValidation}
            onClose={() => setModalOpenValidation(false)}
            isOpen={modalOpenValidation}
          />
        </form>
      )}
      {formName === vulcanForm && (
        <VulcanStatusBar
          step={step}
          isLastStep={steps.length === step}
          isFormTouched={isFormTouched}
          totals={vulcanPricing(formFields, orderData, redeemOfferData)}
          onBackClick={prevStep}
          onProceedClick={nextStep}
          onSaveAndExit={saveAndExit}
          showDownloadQuoteFooter={showDownloadQuoteFooter}
          onQuoteDownload={() =>
            window.open(
              `${apiHost}/orders/${orderData.id}/vulcan-quote-pdf?lang=${locale}`,
              '_blank'
            )
          }
        />
      )}
    </div>
  );
};
FormStepVulcan.propTypes = {
  stepData: PropTypes.shape({
    fields: PropTypes.shape({
      name: PropTypes.string,
      image: PropTypes.string,
      formStepFields: PropTypes.arrayOf(PropTypes.shape({})),
      showTotal: PropTypes.bool,
      modalForms: PropTypes.arrayOf(PropTypes.shape({})),
      backendKey: PropTypes.string
    })
  }),
  steps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  step: PropTypes.number.isRequired,
  updateStep: PropTypes.func,
  setFormRef: PropTypes.func,
  onFormSubmit: PropTypes.func,
  onSaveAndExit: PropTypes.func,
  setOrderData: PropTypes.func,
  orderData: PropTypes.shape({
    id: PropTypes.number,
    productSelectionFM: PropTypes.arrayOf(PropTypes.string),
    managedItServicesData: PropTypes.shape({}),
    microsoftLicensingData: PropTypes.shape({
      adjustedTotalPrice: PropTypes.number
    }),
    managedItServicesSummary: PropTypes.shape({
      totalMonthlyCharges: PropTypes.number,
      totalOneTimeCharges: PropTypes.number
    })
  }),
  hideProgressBar: PropTypes.bool,
  isEditing: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};
FormStepVulcan.defaultProps = {
  stepData: null,
  updateStep: () => {},
  setFormRef: null,
  onFormSubmit: null,
  orderData: {},
  setOrderData: () => {},
  onSaveAndExit: () => {},
  hideProgressBar: false
};
export default FormStepVulcan;
